import { Axios } from 'utils/AxiosConfig'

export const postRegister = async (payload) => {
  const { data: response } = await Axios.post(`register`, payload)
  return response
}
export const postVerifyAcc = async (payload) => {
  const { data: response } = await Axios.post(`verify-account`, payload)
  return response
}
export const postResendAccVerif = async (payload) => {
  const { data: response } = await Axios.post(`resend-account-verification`, payload)
  return response
}
